<style lang='scss'>
	#main-handhomes{
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#quanx_tubody>div{
		padding: 1px 0;
	}
	
	#quanx_tubody{
		background-color: #fff;
		.main-mybody{
			padding: 1rem 1rem 0;
			/* overflow-y: auto; */
			/* min-height: 12rem; */
			/* max-height: 30rem; */
			
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 90%;
			height: 1px;
			border-top: .5px solid #ececec;
			margin-top: .5rem;
			position: relative;
			    top: .2rem;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}

</style>
<template>
	<div>
		<a-modal
		width='54rem'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '15vh' }"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">權限編輯</div>
			</div>
			<div style="display: flex;">
				<div v-for='(item,ind) in titlearr' 
				:key='ind + "0716"' v-if='!item.ishand'
				:class='island == item.firstid?"wland":"gland"' @click="handitem(item)">
					{{item.firstclassname}}</div>
				<div v-if='itemobj.inviter' style="margin-left: auto;font-size: 0.8rem;padding: 0.6rem 0;color: #000000;"
				>邀請編號 : {{itemobj.inviter}}</div>
			</div>
			<div id='quanx_tubody'>
				<messagelist :itemobj='items' ref='weitijao' :islands='island'></messagelist>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import messagelist from './messagelist.vue'
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
		
	export default {
		name:'handhome',
		props:['itemobj','applyid','items'],
		components:{
			messagelist,
			},
		data(){
			return {
				aduit:true,
				tableData:[],
				picList:[],
				isname: '申請假期',
				visible:true,
				island: 2,
				titlearr1:[
					{
						name:'審核記錄',
						component:'',
						island:false,
						// ishand:true
					}],
				titlearr:[
					{
						firstclassname:'證券交易',
						component:'',
						island:true
					},
					{
						firstclassname:'資產管理',
						component:'messagelist',
						island:false
					},
					{
						firstclassname:'人事財務',
						component:'',
						island:false
					},{
						firstclassname:'維護管理',
						component:'',
						island:false,
					},{
						firstclassname:'檔案權限',
						component:'',
						island:false,
					},
				]
			}
		},
		created() {
			let _this = this
			// setTimeout(()=>{
			// 	if(_this.itemobj.status == 2||(_this.itemobj.schedule == 4 && _this.itemobj.status == 0 && !_this.itemobj.aduit)){
			// 		_this.island = 'shenhelist'
			// 	}
			// },100)
		},
		mounted() {
		this.moreEvent();
		},
		watch:{
			itemobj:{
				deep:true,
				immediate:true,
				handler(ev){}
			},
		},
		methods:{
			moreEvent(record=this.itemobj){
			            // token : _this.$store.state.token,
						this.$ajax({
							url:this.$api.getFirstidList,
							method:'post',
							data:{}
						}).then(res=>{
							console.log(res)
							this.titlearr = res.data.firstidListList
						}).catch(err=>{
							console.log(err)
						})
			},
			handitem(item){
				this.island = item.firstid
			},
			getdata(item,record = this.itemobj) {
				this.tableData = []
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.getAdminRemarks, {
					// admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.tableData = data.remarks
						if(data.remarks.length == 0){
							this.$message.warning('暫無審核記錄')
						}else{
							this.island = item.component;
						}
					} else {
						// this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					// console.log(err);
				});
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
